export const styles = {
  text: {
    color: '#fafafa',
    fontSize: 20,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  textLeft: {
    display: 'inline-block',
    color: '#fafafa',
    textAlign: 'left',
  },
  textRight: {
    color: '#fafafa',
    textAlign: 'right',
  },
  title: {
    color: '#fafafa',
    textAlign: 'center',
  },
  subtitle: {
    color: '#b0bec5',
  },
  locationText: {
    color: '#fafafa',
    fontSize: 20,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0px 20px 20px 20px',
  },
  textfieldUnderline: {
    '&:after': {
      borderBottomColor: '#d1c4e9',
    },
  },
  padding15: {
    padding: 0,
  },
  svg: {
    height: 48,
    width: 48,
    display: 'block',
    margin: 'auto',
    filter:
      'invert(100%) sepia(99%) saturate(0%) hue-rotate(110deg) brightness(107%) contrast(100%)',
  },
  svgFajr: {
    height: 48,
    width: 48,
    display: 'block',
    margin: 'auto',
    filter:
      'invert(88%) sepia(22%) saturate(990%) hue-rotate(193deg) brightness(95%) contrast(91%)',
  },
  svgSunrise: {
    height: 48,
    width: 48,
    display: 'block',
    margin: 'auto',
    filter:
      'invert(90%) sepia(9%) saturate(1666%) hue-rotate(309deg) brightness(95%) contrast(114%)',
  },
  svgDhuhr: {
    height: 48,
    width: 48,
    display: 'block',
    margin: 'auto',
    filter:
      'invert(89%) sepia(11%) saturate(925%) hue-rotate(351deg) brightness(104%) contrast(101%)',
  },
  svgAsr: {
    height: 48,
    width: 48,
    display: 'block',
    margin: 'auto',
    filter:
      'invert(92%) sepia(2%) saturate(4954%) hue-rotate(334deg) brightness(101%) contrast(101%)',
  },
  svgMaghrib: {
    height: 48,
    width: 48,
    display: 'block',
    margin: 'auto',
    filter:
      'invert(80%) sepia(5%) saturate(1819%) hue-rotate(292deg) brightness(102%) contrast(95%)',
  },
  svgIsha: {
    height: 48,
    width: 48,
    display: 'block',
    margin: 'auto',
    filter:
      'invert(74%) sepia(65%) saturate(130%) hue-rotate(168deg) brightness(102%) contrast(97%)',
  },
  logo: {
    height: 96,
    width: 96,
    display: 'block',
    margin: 'auto',
    marginTop: 24,
    filter:
      'invert(68%) sepia(41%) saturate(345%) hue-rotate(218deg) brightness(92%) contrast(86%)',
  },
  settingsIcon: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  settingsSelect: {
    margin: '20px',
    padding: '20px',
  },
  footer: {
    position: 'absolute',
    width: '200px',
    left: '50%',
    marginLeft: '-100px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
  },
  footerCreated: {
    color: '#bdbdbd',
  },
  footerName: {
    color: '#f50057',
  },
};
